
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: 'Schedule & Evaluate',
      description: 'Call or stop by for a professional evaluation and schedule your appointment'
    },
    {
      number: '02',
      icon: 'ri-money-dollar-circle-line',
      title: 'Get Your Price',
      description: 'Receive a transparent quote based on your vehicle needs and selected services'
    },
    {
      number: '03',
      icon: 'ri-car-line',
      title: 'Drop Off Your Car',
      description: 'Bring your vehicle to our state-of-the-art facility at your scheduled time'
    },
    {
      number: '04',
      icon: 'ri-cup-line',
      title: 'Relax & Wait',
      description: 'Our expert team works their magic while you enjoy your day worry-free'
    },
    {
      number: '05',
      icon: 'ri-vip-crown-line',
      title: 'Pick Up Perfection',
      description: 'Collect your car looking like the first day you bought it - guaranteed'
    }
  ];

  return (
    <section id="process" className="py-32 bg-gradient-to-b from-primary-black to-primary-dark relative overflow-hidden">
      {/* Enhanced background with more glow */}
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 50% 50%, rgba(0, 212, 255, 0.15) 0%, transparent 60%),
                           radial-gradient(circle at 20% 80%, rgba(0, 102, 255, 0.12) 0%, transparent 50%),
                           radial-gradient(circle at 80% 20%, rgba(0, 212, 255, 0.12) 0%, transparent 50%)`
        }}></div>
        
        {/* Animated glow orbs */}
        <div className="absolute top-1/3 left-1/4 w-72 h-72 bg-primary-blue/15 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-64 h-64 bg-primary-deepblue/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        {/* Horizontal glow lines */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/40 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-primary-blue"></div>
            <span className="text-primary-blue font-inter text-sm font-semibold tracking-widest uppercase" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.8)' }}>
              How It Works
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-primary-blue"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-orbitron font-bold text-white mb-4" style={{ textShadow: '0 0 40px rgba(0, 212, 255, 0.7)' }}>
            YOUR JOURNEY TO PERFECTION
          </h2>
          <p className="text-gray-400 font-inter text-lg">Five simple steps to automotive excellence</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-primary-dark/80 to-primary-black/80 backdrop-blur-sm rounded-3xl p-8 border-2 border-primary-blue/40 transition-all duration-500 hover:-translate-y-4 hover:border-primary-blue cursor-pointer"
              style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.25), inset 0 0 30px rgba(0, 212, 255, 0.05)' }}
            >
              {/* Glow effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-b from-primary-blue/10 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute -inset-0.5 bg-gradient-to-b from-primary-blue/30 to-primary-deepblue/30 rounded-3xl opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-500"></div>
              
              <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                <div className="text-7xl font-orbitron font-black text-transparent bg-clip-text bg-gradient-to-b from-primary-blue to-primary-deepblue" style={{ filter: 'drop-shadow(0 0 20px rgba(0, 212, 255, 0.6))' }}>
                  {step.number}
                </div>

                <div 
                  className="w-18 h-18 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-blue/20 to-primary-deepblue/20 border-2 border-primary-blue group-hover:scale-110 group-hover:border-white transition-all duration-300" 
                  style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5), inset 0 0 15px rgba(0, 212, 255, 0.2)' }}
                >
                  <i className={`${step.icon} text-4xl text-primary-blue group-hover:text-white transition-colors duration-300`}></i>
                </div>

                <h3 className="text-xl font-inter font-bold text-white group-hover:text-primary-blue transition-colors duration-300">
                  {step.title}
                </h3>

                <p className="text-sm text-gray-400 font-inter leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
